export default "__VITE_ASSET__D1WyT13C__"